//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
import "../CAM/CAM.FlowCutSteepContainment.js";
let d=[[[0,"CenterCurve",1,0],[0,"ContactBnd",1,0],[0,"FlowEdit",1,0],[0,"FlowOffsetMode",1,0],[1,"FlowOverlapDistBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"MaxConcavityAngleBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"MergeDistBuilder",0,"CAM.InheritableToolDepBuilder",0],[1,"MinCutLengthBuilder",0,"CAM.InheritableToolDepBuilder",0],[1,"NonSteepCutting",0,"CAM.FlowCutSteepContainment",0],[1,"SteepAngleBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"SteepCutting",0,"CAM.FlowCutSteepContainment",0],[0,"TlDiameter",1,0]],[],[]];
SPLM.CAM.FlowBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.FlowBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.FlowBuilder.FlowOffsetModeType = Object.freeze({
    "Single" : "Single", "Multiple" : "Multiple", "Reftool" : "Reftool"});

SPLM.CAM.FlowBuilder.FlowEditTypes = Object.freeze({
    "Automatic" : "Automatic", "UserDefined" : "UserDefined"});

export default SPLM;